<template>
  <v-tooltip
    class="zoox-component zoox-tooltip"
    :top="!left && !right && !bottom && top"
    :left="left"
    :bottom="bottom"
    :right="right"
    :max-width="maxWidth"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <template #activator="props">
      <!-- 
      @slot slot que envolve o elemento ativador do tooltip
    -->
      <slot name="activator" v-bind="props" />
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
/**
 * @displayName Tooltip
 */
export default {
  name: 'ZTooltip',
  props: {
    /**
     * Flag para colocar o tooltip no topo
     */
    top: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Flag para colocar o tooltip na base do componente
     */
    bottom: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para colocar o tooltip na direita do componente
     */
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para colocar o tooltip na esquerda do componente
     */
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para definir a largura máxima do componente.
     */
    maxWidth: {
      type: [Number, String],
      required: false,
    },

    /**
     * Flag para desabilitar o tooltip
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {}
  },
}
</script>
